export default {
    getPaperGroups: state => {
        return state.paperGroups
    },
    getPaperGroupById: state => id => {
        return state.paperGroups.find(paperGroup => paperGroup.id == id)
    }
}